import {
    FETCH_FORM_DATA,
    FETCH_FORM_IDS_FOR_MULTIPLE_GRADES,
} from '../../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../../actionCreators';

export const sharedFetchFormData = (formUid, client) => async dispatch => {
    const additionalApiParams = {
        apiParams: [formUid],
        additionalResponseParams: { formUid },
    };
    await apiActionCreator(dispatch, FETCH_FORM_DATA, client.getForm, additionalApiParams);
};

export const fetchFormIdsForMultipleGrades = (grades, period, client) => async dispatch => {
    const additionalApiParams = {
        apiParams: [grades, period],
        additionalResponseParams: { period },
    };
    await apiActionCreator(
        dispatch,
        FETCH_FORM_IDS_FOR_MULTIPLE_GRADES,
        client.getFormIdsByGradesPeriod,
        additionalApiParams,
    );
};
